exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deviceTable thead th p-dtcheckbox { display: none !important;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/src/app/component/target_device.component.css
// module id = ../../../../../src/app/component/target_device.component.css
// module chunks = 1